const ErrorStatus = {
  ValidationError: 'validation_error' as const,
  AcceessDenied: 'Access denied' as const,
  InternalServerError: 'Internal Server Error' as const,
};

type ErrorStatus = typeof ErrorStatus[keyof typeof ErrorStatus];

export { ErrorStatus };
